<template>
 <div class="layout-container">
    <div class="layout-canvas-wrap">
      <div class="layout-canvas">

        <div class="row expanded logo" v-if="!fullscreen">
          <partials-header></partials-header>
        </div>

        <router-view></router-view>
      </div>
    </div>
    <partials-footer></partials-footer>
  </div>
</template>

<script>
/* global  */
import PartialsHeader from '../partials/Header'
import PartialsFooter from '../partials/Footer'

export default {
  name: 'layout-secured',
  components: {
    'partials-header': PartialsHeader,
    'partials-footer': PartialsFooter
  },
  props: ['fullscreen'],
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';
  @import '../../sass/layouts/fullscreen';
</style>



// WEBPACK FOOTER //
// LayoutSecured.vue?7a501f60